import React from "react";
import { Typography } from "@material-tailwind/react";
import { 
  MailIcon, 
  LocationMarkerIcon
} from "@heroicons/react/outline";
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn 
} from "react-icons/fa";
import { Link } from "react-router-dom";
import appstore from "../images/appstore.svg";
import playstore from "../images/playstore.svg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    product: [
      { name: "Features", href: "#features" },
      { name: "Pricing", href: "#pricing" },
      { name: "API", href: "#api" },
      { name: "Integrations", href: "#integrations" },
    ],
    company: [
      { name: "About Us", href: "#about" },
      { name: "Careers", href: "#careers" },
      { name: "Press", href: "#press" },
      { name: "Partners", href: "#partners" },
    ],
    support: [
      { name: "Help Center", href: "#help" },
      { name: "Contact Us", href: "#contact" },
      { name: "Status", href: "#status" },
      { name: "Documentation", href: "#docs" },
    ],
    legal: [
      { name: "Privacy Policy", href: "#privacy" },
      { name: "Terms of Service", href: "#terms" },
      { name: "Cookie Policy", href: "#cookies" },
      { name: "GDPR", href: "#gdpr" },
    ],
  };

  const socialLinks = [
    { name: "Facebook", icon: FaFacebookF, href: "https://facebook.com/twerceapp" },
    { name: "Twitter", icon: FaTwitter, href: "https://twitter.com/twerceapp" },
    { name: "Instagram", icon: FaInstagram, href: "https://instagram.com/twerceapp" },
    { name: "LinkedIn", icon: FaLinkedinIn, href: "https://linkedin.com/company/twerceapp" },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 lg:px-8 py-16">
        <div className="grid lg:grid-cols-6 gap-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="mb-6">
              <svg
                width="134"
                height="41"
                viewBox="0 0 134 41"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-10"
              >
                <rect
                  width="21.5018"
                  height="21.5019"
                  transform="matrix(0.717251 0.696815 -0.696748 0.717316 15.2529 7.83353)"
                  fill="#CC5500"
                />
                <rect
                  width="21.5018"
                  height="21.5019"
                  transform="matrix(0.717251 0.696815 -0.696748 0.717316 15.3063 3)"
                  fill="#CC5500"
                />
                <rect
                  width="14.7925"
                  height="14.7925"
                  transform="matrix(0.717251 0.696815 -0.696748 0.717316 15.6796 7.67464)"
                  fill="white"
                />
                <rect
                  width="10.75"
                  height="10.5265"
                  transform="matrix(0.717251 0.696815 -0.696748 0.717316 15.7197 8.11559)"
                  fill="#CC5500"
                />
                <path
                  d="M45.8024 31.62V12.69H38.2124V10.62H55.7024V12.69H48.1124V31.62H45.8024ZM58.9051 31.62L54.6751 16.59H56.8651L60.1051 28.59L63.8551 16.59H65.8351L69.5551 28.59L72.8251 16.59H74.9251L70.6651 31.62H68.5351L64.8151 19.59L61.0651 31.62H58.9051ZM83.9959 31.89C82.5559 31.89 81.2459 31.55 80.0659 30.87C78.9059 30.17 77.9759 29.23 77.2759 28.05C76.5959 26.87 76.2559 25.55 76.2559 24.09C76.2559 22.65 76.5859 21.35 77.2459 20.19C77.9059 19.01 78.7959 18.08 79.9159 17.4C81.0359 16.7 82.2859 16.35 83.6659 16.35C85.0059 16.35 86.2059 16.7 87.2659 17.4C88.3459 18.08 89.1959 19.01 89.8159 20.19C90.4559 21.35 90.7759 22.65 90.7759 24.09V24.78H78.4459C78.5659 25.76 78.8759 26.64 79.3759 27.42C79.8959 28.2 80.5659 28.82 81.3859 29.28C82.2059 29.72 83.1059 29.94 84.0859 29.94C84.8659 29.94 85.6259 29.82 86.3659 29.58C87.1059 29.34 87.7259 29 88.2259 28.56L89.6059 30.03C88.7659 30.65 87.8859 31.12 86.9659 31.44C86.0659 31.74 85.0759 31.89 83.9959 31.89ZM78.5059 23.01H88.5559C88.4359 22.11 88.1359 21.31 87.6559 20.61C87.1959 19.89 86.6159 19.33 85.9159 18.93C85.2159 18.51 84.4459 18.3 83.6059 18.3C82.7459 18.3 81.9559 18.5 81.2359 18.9C80.5159 19.3 79.9159 19.86 79.4359 20.58C78.9559 21.28 78.6459 22.09 78.5059 23.01ZM93.8795 31.62V16.59H96.0995V18.72C96.5595 17.94 97.1395 17.34 97.8395 16.92C98.5595 16.48 99.3795 16.26 100.299 16.26C100.819 16.26 101.289 16.33 101.709 16.47V18.51C101.449 18.41 101.189 18.34 100.929 18.3C100.669 18.26 100.409 18.24 100.149 18.24C99.2295 18.24 98.4195 18.51 97.7195 19.05C97.0395 19.57 96.4995 20.33 96.0995 21.33V31.62H93.8795ZM110.156 31.89C108.736 31.89 107.446 31.55 106.286 30.87C105.126 30.17 104.206 29.23 103.526 28.05C102.846 26.87 102.506 25.55 102.506 24.09C102.506 22.63 102.846 21.32 103.526 20.16C104.206 18.98 105.126 18.04 106.286 17.34C107.446 16.64 108.736 16.29 110.156 16.29C111.256 16.29 112.316 16.5 113.336 16.92C114.356 17.32 115.256 17.9 116.036 18.66L114.626 20.28C114.026 19.64 113.336 19.16 112.556 18.84C111.796 18.5 111.006 18.33 110.186 18.33C109.166 18.33 108.236 18.59 107.396 19.11C106.576 19.61 105.916 20.3 105.416 21.18C104.936 22.04 104.696 23.01 104.696 24.09C104.696 25.17 104.936 26.15 105.416 27.03C105.916 27.91 106.586 28.61 107.426 29.13C108.266 29.63 109.196 29.88 110.216 29.88C111.036 29.88 111.806 29.72 112.526 29.4C113.266 29.08 113.956 28.61 114.596 27.99L115.976 29.49C115.176 30.25 114.276 30.84 113.276 31.26C112.276 31.68 111.236 31.89 110.156 31.89ZM125.187 31.89C123.747 31.89 122.437 31.55 121.257 30.87C120.097 30.17 119.167 29.23 118.467 28.05C117.787 26.87 117.447 25.55 117.447 24.09C117.447 22.65 117.777 21.35 118.437 20.19C119.097 19.01 119.987 18.08 121.107 17.4C122.227 16.7 123.477 16.35 124.857 16.35C126.197 16.35 127.397 16.7 128.457 17.4C129.537 18.08 130.387 19.01 131.007 20.19C131.647 21.35 131.967 22.65 131.967 24.09V24.78H119.637C119.757 25.76 120.067 26.64 120.567 27.42C121.087 28.2 121.757 28.82 122.577 29.28C123.397 29.72 124.297 29.94 125.277 29.94C126.057 29.94 126.817 29.82 127.557 29.58C128.297 29.34 128.917 29 129.417 28.56L130.797 30.03C129.957 30.65 129.077 31.12 128.157 31.44C127.257 31.74 126.267 31.89 125.187 31.89ZM119.697 23.01H129.747C129.627 22.11 129.327 21.31 128.847 20.61C128.387 19.89 127.807 19.33 127.107 18.93C126.407 18.51 125.637 18.3 124.797 18.3C123.937 18.3 123.147 18.5 122.427 18.9C121.707 19.3 121.107 19.86 120.627 20.58C120.147 21.28 119.837 22.09 119.697 23.01Z"
                  fill="#CC5500"
                />
              </svg>
            </div>
            
            <Typography
              variant="p"
              className="text-gray-300 mb-6 leading-relaxed"
              style={{ fontFamily: 'Open Sans, sans-serif' }}
            >
              Twerce is the leading B2B marketplace connecting buyers with verified suppliers. 
              Streamline your procurement process and grow your business with our innovative platform.
            </Typography>

            {/* Contact Info */}
            <div className="space-y-3 mb-6">
              <div className="flex items-center text-gray-300">
                <MailIcon className="w-5 h-5 mr-3 text-CC5500" />
                <span style={{ fontFamily: 'Open Sans, sans-serif' }}>contact@twerce.com</span>
              </div>
              <div className="flex items-center text-gray-300">
                <LocationMarkerIcon className="w-5 h-5 mr-3 text-CC5500" />
                <span style={{ fontFamily: 'Open Sans, sans-serif' }}>Lagos, Nigeria</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-CC5500 transition-colors duration-200"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Links Sections */}
          <div className="lg:col-span-4 grid grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Product</h3>
              <ul className="space-y-3">
                {footerLinks.product.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-300 hover:text-white transition-colors duration-200"
                      style={{ fontFamily: 'Open Sans, sans-serif' }}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Company</h3>
              <ul className="space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-300 hover:text-white transition-colors duration-200"
                      style={{ fontFamily: 'Open Sans, sans-serif' }}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Support</h3>
              <ul className="space-y-3">
                {footerLinks.support.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-300 hover:text-white transition-colors duration-200"
                      style={{ fontFamily: 'Open Sans, sans-serif' }}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4 text-white">Legal</h3>
              <ul className="space-y-3">
                {footerLinks.legal.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-gray-300 hover:text-white transition-colors duration-200"
                      style={{ fontFamily: 'Open Sans, sans-serif' }}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Download Apps Section */}
        <div className="mt-16 pt-8 border-t border-gray-800">
          <div className="flex flex-col lg:flex-row justify-between items-center">
            <div className="mb-6 lg:mb-0">
              <h3 className="text-xl font-semibold mb-2 text-white">
                Download Our App
              </h3>
              <p className="text-gray-300" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                Get the full Twerce experience on your mobile device
              </p>
            </div>
            <div className="flex space-x-4">
              <Link to="https://apps.apple.com/ng/app/twerce/id6477323743">
                <button className="transition-transform duration-200 hover:scale-105">
                  <img src={appstore} alt="Download on App Store" className="h-12" />
                </button>
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.twerceapp.twerce">
                <button className="transition-transform duration-200 hover:scale-105">
                  <img src={playstore} alt="Download on Google Play" className="h-12" />
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 lg:px-8 py-6">
          <div className="flex flex-col lg:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 lg:mb-0" style={{ fontFamily: 'Open Sans, sans-serif' }}>
              © {currentYear} Twerce. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <a href="#privacy" className="text-gray-400 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                Privacy Policy
              </a>
              <a href="#terms" className="text-gray-400 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                Terms of Service
              </a>
              <a href="#cookies" className="text-gray-400 hover:text-white text-sm transition-colors duration-200" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                Cookie Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
